import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'

import { fetchNextSchedules } from 'services/me'
import { useUnleashVariant, featureName } from 'modules/FeatureFlags/Unleash'
import { UserData } from 'models/Auth'
import { PATIENT_SAVED_PLAN } from 'settings/_storageFlagsSettings'

// Esse hook vai ser utilizado temporariamente para validar a feature de transcrição de áudio com um grupo específico de pacientes
// TODO: Remover quando a feature flag for removida e a feature estiver implementada para todos os pacientes

export const useAudioTranscriptionEligibility = () => {
  const variant = useUnleashVariant(featureName.ENABLE_AUDIO_TRANSCRIPTION)
  const user = useSelector((state: UserData) => state.auth)
  const userSelectedPlan = localStorage.getItem(PATIENT_SAVED_PLAN) || user?.planSelected?.partner_plan_code

  const { data: nextSchedules, isLoading } = useQuery({
    queryKey: ['PATIENT_NEXT_SCHEDULE', userSelectedPlan],
    queryFn: fetchNextSchedules,
    enabled: variant.enabled,
  })

  if (!variant.enabled) return { showFeature: false }
  if (isLoading) return { showFeature: false }

  try {
    const payload = JSON.parse(variant.payload?.value || '{}')
    const targetProfessionals: string[] = payload.professional_usernames || []

    const showFeature = (nextSchedules || []).some(
      schedule => targetProfessionals.includes(schedule.professionalUsername)
    )

    return { showFeature }
  } catch {
    return { showFeature: false }
  }
}
